import { useState, useEffect } from 'react';
import { getVolunteerHoursByVolunteerId, getVolunteerStats } from '@/lib/firebase/queries/volunteerHours';
import type { VolunteerHour, VolunteerStats } from '@/types/volunteer';

export function useVolunteerHours(volunteerId?: string) {
  const [hours, setHours] = useState<VolunteerHour[]>([]);
  const [stats, setStats] = useState<VolunteerStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!volunteerId) {
      setLoading(false);
      return;
    }

    fetchVolunteerData();
  }, [volunteerId]);

  const fetchVolunteerData = async () => {
    if (!volunteerId) return;

    try {
      setLoading(true);
      setError(null);

      const [hoursData, statsData] = await Promise.all([
        getVolunteerHoursByVolunteerId(volunteerId),
        getVolunteerStats(volunteerId),
      ]);

      setHours(hoursData);
      setStats(statsData);
    } catch (err) {
      console.error('Error fetching volunteer data:', err);
      setError('Failed to load volunteer hours');
    } finally {
      setLoading(false);
    }
  };

  return {
    hours,
    stats,
    loading,
    error,
    refetch: fetchVolunteerData,
  };
}

